/**
 * Utility functions for date calculations in monetization forms
 */

/**
 * Calculates the number of days between two dates
 * @param startDate - The start date (emission date)
 * @param endDate - The end date (due date)
 * @returns The number of days between the dates, or 0 if dates are invalid
 */
export const calculateDaysBetweenDates = (startDate: string, endDate: string): number => {
  if (!startDate || !endDate) return 0;
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Validate dates
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
  
  // Calculate difference in milliseconds and convert to days
  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays >= 0 ? diffDays : 0;
};

/**
 * Calculates term in days for monetization forms
 * @param issueDate - The emission date
 * @param dueDate - The due date
 * @returns The calculated term in days
 */
export const calculateTermInDays = (issueDate: string, dueDate: string): number => {
  return calculateDaysBetweenDates(issueDate, dueDate);
};